// Root. Wires the shell, global state providers, and the four pages (Builder /
// Strategies / Monitor / Channels). Page content lives in its own folder under
// components/<page>/.

import { AppShell } from "./components/shell/AppShell";
import { BuilderStateProvider } from "./state/BuilderState";
import { SelectedStrategyProvider } from "./state/SelectedStrategyContext";
import { BuilderPage } from "./components/builder/BuilderPage";
import { StrategiesPage } from "./components/strategies/StrategiesPage";
import { MonitorPage } from "./components/monitor/MonitorPage";
import { ChannelsPage } from "./components/channels/ChannelsPage";

export default function App() {
  return (
    <BuilderStateProvider>
      <SelectedStrategyProvider>
        <AppShell
          pages={{
            builder: <BuilderPage />,
            strategies: <StrategiesPage />,
            monitor: <MonitorPage />,
            channels: <ChannelsPage />,
          }}
        />
      </SelectedStrategyProvider>
    </BuilderStateProvider>
  );
}
